import { DocumentReference, FirestoreDataConverter } from "firebase/firestore";
import { map, omitBy } from "lodash";
import moment from "moment";
import { SituacaoUpload } from "../models/enum";
import Upload, { Periodo } from "../models/upload";
import BaseDb from "./baseDb";
import toFirestore from "./toFirestore";
import NotaDb from "./notaDb";
import ExercicioDireitoDb from "./exercicioDireitoDb";
import CheckpointDb from "./checkpointDb";

export default class UploadDb extends BaseDb<
  Upload,
  { usuarioId: string; uploadId: string }
> {
  _path: string = "usuarios/usuarioId/uploads/uploadId";
  getConverter(): FirestoreDataConverter<Upload> {
    return {
      fromFirestore: (snapshot, _options) => {
        switch (snapshot.get("situacao")) {
          case SituacaoUpload.SALVO:
          case SituacaoUpload.ERRO_AO_LER:
          case SituacaoUpload.ERRO_AO_IMPORTAR:
            return new Upload({
              id: snapshot.id,
              arquivo: snapshot.get("arquivo"),
              erro: snapshot.get("erro"),
              senhaProtegida: snapshot.get("senhaProtegida"),
              situacao: snapshot.get("situacao"),
              tipo: snapshot.get("tipo"),
              nomeArquivoOriginal: snapshot.get("nomeArquivoOriginal"),
              dataUpload: snapshot.get("dataUpload")
                ? moment(snapshot.get("dataUpload").toDate())
                : undefined,
              conexao: snapshot.get("conexao"),
              incompatibilidades: snapshot.get("incompatibilidades"),
            });

          default:
            return new Upload({
              id: snapshot.id,
              dataEmissao: moment(snapshot.get("dataEmissao").toDate()),
              corretora: snapshot.get("corretora"),
              periodo: {
                de: moment(snapshot.get("periodo").de.toDate()),
                a: moment(snapshot.get("periodo").a.toDate()),
              } as Periodo,
              situacao: snapshot.get("situacao"),
              tipo: snapshot.get("tipo"),
              nomeArquivoOriginal: snapshot.get("nomeArquivoOriginal"),
              dataUpload: snapshot.get("dataUpload")
                ? moment(snapshot.get("dataUpload").toDate())
                : undefined,
              arquivo: snapshot.get("arquivo"),
              quantidadePregoes: snapshot.get("quantidadePregoes"),
              quantidadeParciais: snapshot.get("quantidadeParciais"),
              novosPregoes: snapshot.get("novosPregoes"),
              senhaProtegida: snapshot.get("senhaProtegida"),
              conexao: snapshot.get("conexao"),
              incompatibilidades: snapshot.get("incompatibilidades"),
              itensImportados: snapshot.get("itensImportados")
                ? map(
                    snapshot.get("itensImportados"),
                    (ref: DocumentReference) => {
                      switch (ref.parent.id) {
                        case "exercicioDireito":
                          return ref.withConverter(
                            new ExercicioDireitoDb().getConverter()
                          );
                        case "checkpoints":
                          return ref.withConverter(
                            new CheckpointDb().getConverter()
                          );
                        case "notas":
                        default:
                          return ref.withConverter(new NotaDb().getConverter());
                      }
                    }
                  )
                : undefined,
            });
        }
      },
      toFirestore: (upload: Upload) => toFirestore(omitBy(upload, ["id"])),
    };
  }
}
